import React, { SetStateAction, useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { useTranslation } from 'react-i18next';

import { SemenTypeOptions } from '@/types';

import { usePullODSemen } from '../../../services/semen-pull/hooks';
import { useSemenPullContext } from '../useSemenPullContext';

type Props = {
  selectSemenVisible: boolean;
  setSelectSemenVisible: React.Dispatch<SetStateAction<boolean>>;
  resetODSemenDialog: () => void;
};
export const PullODSemenDialog = ({
  selectSemenVisible,
  setSelectSemenVisible,
  resetODSemenDialog,
}: Props) => {
  const { t } = useTranslation();
  const {
    ODselectedSemen,
    setODselectedSemen,
    refetchPulledSemen,
    refetchScheduledSemen,
  } = useSemenPullContext();
  const [selectedSemenType, setSelectedSemenType] = useState<string | null>(
    null,
  );
  const [selectedQuantity, setSelectedQuantity] = useState<number | null>(null);

  const pullODSemen = usePullODSemen();

  useEffect(() => {
    if (ODselectedSemen?.semenTypeName) {
      setSelectedSemenType(ODselectedSemen.semenTypeName);
    }
  }, [ODselectedSemen]);

  const handlePullODSemen = async () => {
    try {
      await pullODSemen.mutateAsync({
        semenId: ODselectedSemen?.semenID as string,
        semenType: selectedSemenType as string,
        moveNum: selectedQuantity as number,
      });
      setSelectSemenVisible(false);
      resetODSemenDialog();
      refetchScheduledSemen();
      refetchPulledSemen();
    } catch (error) {
      console.error('Error pulling OD semen:', error);
      throw error;
    }
  };

  return (
    <Dialog
      visible={selectSemenVisible}
      style={{ width: '50vw' }}
      onHide={() => {
        if (!selectSemenVisible) return;
        setSelectedQuantity(null);
        setSelectedSemenType(null);
        setODselectedSemen(undefined);
        setSelectSemenVisible(false);
      }}
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <label htmlFor="">Semen Name:</label>
          <div>{ODselectedSemen?.semenName}</div>
        </div>
        <div className="flex flex-col gap-2">
          <label htmlFor="">Semen Type:</label>
          <Dropdown
            value={selectedSemenType}
            onChange={(e) => setSelectedSemenType(e.value)}
            options={SemenTypeOptions || []}
            optionLabel="label"
            placeholder={ODselectedSemen?.semenTypeName as string}
            className="md:w-14rem w-full"
            optionValue="value"
          />
        </div>
        <div className="flex flex-col gap-2">
          <label htmlFor="">Quantity Available:</label>
          <div>{ODselectedSemen?.quantity}</div>
        </div>
        <div className="flex flex-col gap-2">
          <label htmlFor="">Quantity to Pull:</label>
          <InputNumber
            value={selectedQuantity}
            onValueChange={(e) => setSelectedQuantity(e.value as number)}
            showButtons
          />
        </div>
        <div className="flex justify-end">
          <Button
            label={t('semen.pullSemen')}
            onClick={handlePullODSemen}
            loading={pullODSemen.isPending}
            disabled={!selectedSemenType || !selectedQuantity}
          />
        </div>
      </div>
    </Dialog>
  );
};
